import { z } from 'zod';
import { MEDIA_KINDS } from './protocol';

/** Request shapes for the Worker's SFU proxy under /office/floors/:id/rtc. */

const sdp = z.string().min(1).max(200_000);
const mid = z.string().min(1).max(16);
export const videoQualitySchema = z.enum(['high', 'mid', 'low']);

export const rtcSessionSchema = z.object({ role: z.enum(['pub', 'sub']) });
export type RtcSessionInput = z.infer<typeof rtcSessionSchema>;

export const rtcPublishSchema = z.object({
  sdp,
  tracks: z.array(z.object({ mid, kind: z.enum(MEDIA_KINDS) })).min(1).max(8),
});
export type RtcPublishInput = z.infer<typeof rtcPublishSchema>;

export const rtcPullSchema = z.object({
  tracks: z.array(z.object({ userId: z.string().min(1).max(64), kind: z.enum(MEDIA_KINDS), quality: videoQualitySchema.optional() })).min(1).max(32),
});
export type RtcPullInput = z.infer<typeof rtcPullSchema>;

export const rtcRenegotiateSchema = z.object({ type: z.enum(['offer', 'answer']), sdp });
export type RtcRenegotiateInput = z.infer<typeof rtcRenegotiateSchema>;

export const rtcCloseSchema = z.object({ mids: z.array(mid).min(1).max(32), sdp: sdp.optional() });
export type RtcCloseInput = z.infer<typeof rtcCloseSchema>;

export const rtcLayerSchema = z.object({ mid, quality: videoQualitySchema });
export type RtcLayerInput = z.infer<typeof rtcLayerSchema>;

/** What the proxy returns for publish and pull. */
export interface RtcTracksResult {
  /** The SFU's answer (publish) or offer (pull), when it sent one. */
  sdp: string | null;
  type: 'offer' | 'answer' | null;
  requiresRenegotiation: boolean;
  tracks: { mid: string | null; userId: string; kind: string; error: string | null }[];
}
